function outsidePromiseBuilder () {
  let resolve, reject;
  // eslint-disable-next-line promise/param-names
  const promise = new Promise(($resolve, $reject) => { resolve = $resolve; reject = $reject; });
  Object.defineProperty(promise, '$resolve', { value: resolve });
  Object.defineProperty(promise, '$reject', { value: reject });

  return promise;
}

const requestCache = {
  cache: {},
  getKey (config) {
    return config ? config.url + '?' + JSON.stringify(config.params) : null;// + JSON.stringify(config.headers);
  },
  isCached (config) {
    return !!this.cache[this.getKey(config)];
  },
  cacheRequest (config) {
    this.cache[this.getKey(config)] = { config, promise: outsidePromiseBuilder(), listeners: [] };
  },
  shouldThrottle (config) {
    return config.method === 'get' && config.headers['Cache-Control'] !== 'no-cache';
  },
  setCachedResponse (config, response) {
    this.cache[this.getKey(config)].listeners.forEach(listener => listener.$resolve(response));

    this.deleteCache(config);
  },
  setCachedResponseError (config, error) {
    this.cache[this.getKey(config)].listeners.forEach(listener => listener.$reject(error));

    this.deleteCache(config);
  },
  waitForCachedresponse (config) {
    const promise = outsidePromiseBuilder();
    this.cache[this.getKey(config)].listeners.push(promise);
    return promise;
  },
  deleteCache (config) {
    this.cache[this.getKey(config)] = null;
    delete this.cache[this.getKey(config)];
  }
};

export default {
  requestHandler: config => {
    if (requestCache.isCached(config)) {
      const skipXHRError = new Error('skip');
      skipXHRError.isSkipXHR = true;
      skipXHRError.promise = requestCache.waitForCachedresponse(config);
      throw skipXHRError;
    } else {
      if (requestCache.shouldThrottle(config)) {
        requestCache.cacheRequest(config);
      }
      return config;
    }
  },

  responseHandler: response => {
    if (requestCache.shouldThrottle(response.config)) {
      requestCache.setCachedResponse(response.config, response);
    }
    return response;
  },

  errorHandler: error => {
    if (error.isSkipXHR) {
      return error.promise;
    }
    if (requestCache.shouldThrottle(error.config)) {
      requestCache.setCachedResponseError(error.config, error);
    }

    return Promise.reject(error);
  }
};
